import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const SolicitudDePersonalDelete = ({
  rowInfo,
  open,
  setOpen,
  getSolicitud,
  mostrarAlerta,
}) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  // Row info { id, activa}

  const handleClick = async () => {
    const cambioActiva = rowInfo.activa === 1 ? 0 : 1;
    const solicitudActualizada = {
      activa: cambioActiva,
      candidato_seleccionado: null,
    };
    try {
      const response = await fetch(
        `${UrlApi}/solicitudDePersonal/${rowInfo.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(solicitudActualizada),
        }
      );
      if (response.ok) {
        mostrarAlerta(
          "La solicitud ha sido desactivada correctamente",
          "success"
        );
      } else {
        throw new Error("Error en la solicitud");
      }
      await getSolicitud();
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
      mostrarAlerta(
        "Hubo un problema al eliminar la solicitud de trabajo. Intente nuevamente.",
        "error"
      );
    }

    logEventos(
      "Eliminado solicitud de trabajo",
      "Solicitud de trabajo",
      "Desactivando de la DB una solicitud",
      localStorage.getItem("user")
    );

    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
    >
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              {rowInfo.activa === 1
                ? "Desactivar solicitud de trabajo"
                : "Activar solicitud de trabajo"}
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          {rowInfo.activa === 1
            ? "¿Esta seguro que quiere desactivar la solicitud?"
            : "¿Esta seguro que quiere activar la solicitud?"}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={handleClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={handleClick}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default SolicitudDePersonalDelete;
